import 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';

import { WorkshopPayService } from './workshoppay.service';

angular.module('app-lite.workshopPay', [])
  .service('workshopPayApi', downgradeInjectable(WorkshopPayService));
